var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NetworkForm',{attrs:{"handle-submit":_vm.handleSubmit,"defaults":_vm.defaults,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }